import React from "react";
import { logout } from "react-icons-kit/iconic/logout";
import { speedometer } from "react-icons-kit/ionicons/speedometer";
import { gear } from "react-icons-kit/fa/gear";
import { navBarItemsTimps, navBarItemsSITE, navBarItemseUtility, navBarItemsLITE } from "./timps.Nav";
import { support } from "react-icons-kit/typicons/support";
import { NavTimpsWraper } from "./ReVAMP.Nav";
import { NavElement, NavImg, NavData, CustomNav } from "components/Common/Forms/formsMiscItems.jsx";
import { withRouter } from "react-router-dom";
import NavRow from "./NavRow";
import { warning } from "react-icons-kit/icomoon/warning";
import { SideNavBarStyle } from "./style/SideNavBar";
import { themeService } from "theme/service/activeTheme.service";
//const theme = themeService("");
import TIMPS_Logo_new from "../../TIMPS_Logo_new.png";
import TIMPS_Logo from "../../TIMPS_Logo.png";
import ReVAMP_Logo from "../../ReVAMP_Logo.png";
import BIS_Logo from "../../BIS_Logo.png";
import sideBarLogo from "../../logo-sidebar.png";
import SCIMS from "../../SCIM 1.png";
import { versionInfo } from "../MainPage/VersionInfo";
import { isSuperAdminRole, isUserEmailInList } from "../MainPage/UserInfo";
//import { timpsSignalApp } from "../../config/config";

class SideNavBar extends React.Component {
  constructor(props) {
    super(props);

    // this.navBarItems = [
    //   {
    //     navId: "dashboard",
    //     navIndex: 1,
    //     navIcon: speedometer,
    //     navText: "Dashboard",
    //     permissionCheckFirstArg: "DASHBOARD",
    //     permissionCheckSecondArg: "view",
    //     permissionCheck: true,
    //   },

    //   {
    //     navId: "reportSummary",
    //     navIndex: 11,
    //     navIcon: warning,
    //     navText: "Violations",
    //     permissionCheckFirstArg: "REPORT SUMMARY",
    //     permissionCheckSecondArg: "view",
    //     permissionCheck: true,
    //   },

    //   {
    //     navId: "setup/staff",
    //     navIndex: 14,
    //     navIcon: gear,
    //     navText: "Setup",
    //     permissionCheckFirstArg: "SETUP",
    //     permissionCheckSecondArg: "view",
    //     permissionCheck: true,
    //   },
    // ];

    this.onLinkClick = this.onLinkClick.bind(this);
    this.prepareNavItems = this.prepareNavItems.bind(this);
    this.navBarItems = this.prepareNavItems();
  }

  prepareNavItems() {
    let defaultNavBarItems = [
      {
        navId: "dashboard",
        navIndex: 1,
        navIcon: speedometer,
        navText: "Dashboard",
        permissionCheckFirstArg: "DASHBOARD",
        permissionCheckSecondArg: "view",
        permissionCheck: true,
      },

      {
        navId: "reportSummary",
        navIndex: 11,
        navIcon: warning,
        navText: "Violations",
        permissionCheckFirstArg: "REPORT SUMMARY",
        permissionCheckSecondArg: "view",
        permissionCheck: true,
      },

      {
        navId: "setup/staff",
        navIndex: 16,
        navIcon: gear,
        navText: "Setup",
        permissionCheckFirstArg: "SETUP",
        permissionCheckSecondArg: "view",
        permissionCheck: true,
      },
    ];
    let itemsToAdd = navItemsDecider(this.props.applicationType);
    let supportNavItem = [];
    let user = localStorage.getItem("loggedInUser");
    if (isUserEmailInList(["superadmin@timps.com", "admin@tektracking.com"])) {
      supportNavItem.push({
        navId: "support",
        navIndex: 13,
        navIcon: support,
        navText: "Support",
        permissionCheck: false,
      });
    }
    return [...defaultNavBarItems, ...supportNavItem, ...NavTimpsWraper, ...itemsToAdd].sort(function (a, b) {
      return a.navIndex - b.navIndex;
    });
  }

  onLinkClick(navItem) {
    this.props.history.push("/${navItem}");
  }

  componentDidMount() {}

  render() {
    //console.log(theme);
    //console.log(SideNavBarStyle.sideNav[theme]);
    let timpsSignalApp = !!(this.props.applicationType === "SITE");
    let LampApp = !!(this.props.applicationType === "ReVAMP");
    let electricapp = this.props.applicationType === "EUtility";
    return (
      <React.Fragment>
        <div
          id="sideNav"
          className="scrollbar"
          style={{
            ...themeService(SideNavBarStyle().sideNav),
            width: this.props.sidebarWidth,
            left: this.props.sideNavDispaly,
          }}
        >
          <div style={themeService({ default: { display: "none" }, retro: { textAlign: "center" }, electric: { textAlign: "center" } })}>
            {!electricapp && (
              <img
                src={timpsSignalApp ? SCIMS : LampApp ? ReVAMP_Logo : versionInfo.isBridge() ? BIS_Logo : TIMPS_Logo}
                style={{ width: "160px", top: "0", left: "14px" }}
              />
            )}
          </div>
          {
            <CustomNav>
              <NavRow
                navBarItems={this.navBarItems}
                onLinkClick={this.onLinkClick}
                history={this.props.history}
                textDisplay={this.props.textDisplay}
                sidebarWidth={this.props.sidebarWidth}
                hideToolTip={this.props.hideToolTip}
              />
            </CustomNav>
          }
          {/* <div style={{ position: "absolute", bottom: "75px" }}>
            <img src={sideBarLogo} alt="" style={{ width: "190px" }} />
          </div> */}
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(SideNavBar);

function navItemsDecider(appType) {
  return navItemsTypes[appType] ? navItemsTypes[appType] : [];
}

const navItemsTypes = {
  TIMPS: navBarItemsTimps,
  SITE: navBarItemsSITE,
  EUtility: navBarItemseUtility,
  ReVAMP: navBarItemsLITE,
};



// WEBPACK FOOTER //
// ./src/components/SideNavBar/SideNavBar.jsx